import { Grid } from '@mui/material';
import { Bar } from 'react-chartjs-2';
import NoDataComponent from '../../../common/NoDataComponent'; // Import the new component

const DayWiseHourReport = ({ data }) => (
  <Grid container>
    <Grid item xs={12}>
      {data && data?.labels.length > 0 ? (
        <div className="barContainer">
          <Bar
            options={{
              scales: {
                y: {
                  display: false,
                },
              },
              responsive: true,
              plugins: {
                datalabels: {
                  formatter(value) {
                    return `${value.toString().replace('.', 'h ')}m`;
                  },
                },
              },
            }}
            data={{
              labels: data?.labels,
              datasets: [
                {
                  label: 'Hours',
                  data: data?.data,
                  backgroundColor: 'rgba(53, 162, 235, 0.5)',
                },
              ],
            }}
            height={100}
          />
        </div>
      ) : (
        <NoDataComponent />
      )}
    </Grid>
  </Grid>
);

export default DayWiseHourReport;
